import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification, Statistic, Modal } from "antd";
import { CustomTable } from "../utils/CustomComponents";
import {
	DownloadOutlined,
	FilePdfFilled,
	RetweetOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { useRef } from "react";
import { CSVLink } from "react-csv";

const { Text } = Typography;

const JobLoadsRateModal = ({
	modalOpenLoads,
	setModalOpenLoads,
	selectedJob,
	setSelectedJob,
	history,
}) => {
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadList, setLoadList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const refDownload = useRef();
	const [refresh, setRefresh] = useState(false);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columnsLoads = [
		{
			title: "Driver",
			dataIndex: "driver",
			key: "driver",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Load (YD3)",
			dataIndex: "yards",
			key: "yards",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Loaded",
			dataIndex: "loadedDate",
			key: "loadedDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Arrive To Job",
			dataIndex: "toArriveDate",
			key: "toArriveDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Start Unload",
			dataIndex: "startUnloadDate",
			key: "startUnloadDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Finish Unload",
			dataIndex: "finishUnloadDate",
			key: "finishUnloadDate",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Rate / CY",
			dataIndex: "rateCY",
			key: "rateCY",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Delivery Ticket",
			dataIndex: "deliveryTicket",
			key: "deliveryTicket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Order Code",
			dataIndex: "orderCode",
			key: "orderCode",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Sequence",
			dataIndex: "sequence",
			key: "sequence",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		if (selectedJob) getLoadList();
	}, [refresh, selectedJob]);

	const getLoadList = async () => {
		try {
			setLoadingTable(true);
			const url = api + `/job/get/57logistics/loads/${selectedJob.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						deliveryTicket: item.deliveryTicket,
						truck: item.truck.number,
						driver: item.driverId.name || item.driver,
						yards: item.yards,
						sequence: item.sequence,
						orderCode: item.orderCode,
						toArriveDate: item.toArriveDate
							? dayjs(item.toArriveDate)
									.add(5, "hour")
									.format("MM/DD/YYYY HH:mm A")
							: "-",
						startUnloadDate: item.startUnloadDate
							? dayjs(item.startUnloadDate)
									.add(5, "hour")
									.format("MM/DD/YYYY HH:mm A")
							: "-",
						finishUnloadDate: item.finishUnloadDate
							? dayjs(item.finishUnloadDate)
									.add(5, "hour")
									.format("MM/DD/YYYY HH:mm A")
							: "-",
						loadedDate: dayjs(item.date).format("MM/DD/YYYY HH:mm A"),
						rateCY: item.minutesDiff || "-",
					});
				});
				setLoadList(list);
				setLoadingTable(false);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const headers = () => {
		return columnsLoads.map((item) => {
			return {
				key: item.key,
				label: item.title,
			};
		});
	};

	return (
		<Modal
			title={`Job ID: ${selectedJob?.number}`}
			open={modalOpenLoads}
			onCancel={() => {
				setSelectedJob(null);
				setModalOpenLoads(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			<Flex vertical gap={16}>
				<Button
					type="primary"
					onClick={() => setRefresh((prev) => !prev)}
					icon={<RetweetOutlined />}
					size="large"
					loading={loadingTable}
				/>
				<CustomTable
					columns={columnsLoads}
					data={loadList}
					loading={loadingTable}
				/>
				<Flex justify={"flex-end"} gap={16} align="center">
					{selectedJob && !selectedJob.deliveryRate && (
						<Text type="secondary">
							Delivery Rate Must be assign to generate report
						</Text>
					)}
					{loadList.length > 0 && (
						<>
							<CSVLink
								data={loadList}
								headers={headers()}
								filename={`57concrete-${selectedJob?.number}-loads.csv`}
								hidden
								ref={refDownload}
							>
								Download report
							</CSVLink>
							<Button
								size="large"
								type="primary"
								icon={<DownloadOutlined />}
								onClick={(e) => refDownload.current.link.click()}
								loading={loadingTable}
							>
								Download Report
							</Button>
						</>
					)}
					<Button
						type="primary"
						size="large"
						icon={<FilePdfFilled />}
						loading={loadingTable}
						disabled={selectedJob && selectedJob.deliveryRate ? false : true}
						onClick={() =>
							history.push(
								`/57logistics/concretesupplyperformance/pdf/${selectedJob.id}`,
							)
						}
					>
						Generate PDF
					</Button>
				</Flex>
			</Flex>
			{contextHolder}
		</Modal>
	);
};

export default JobLoadsRateModal;
